import Vue from 'vue';
import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'userManager';
root.data = {
	titleName: '',
	//当前账号针对部门的权限
	thisDeptAuthorize: {
		add: false,
		del: false,
		edit: false,
		look: false,
		addUser: false,
		delUser: false,
	},
	//部门列表数据
	deptDataList: {
		list: [],
		//总页数
		total: 1,
		//当前页数
		thisPage: 1,
		//每页多少行
		limit: 10
	},

	thisEdit: {
		//仅仅用来展开基本信息
		nameOpen: '1',
		//操作类型（保存按钮是添加部门还是修改部门）
		operaType: 'add',
		//操作的数据
		deptDataOperat: {
			//基本信息到数据
			deptData: {
				//名称
				name: '',
				//说明
				remark: ''
			},
			//部门人员的数据
			userList: {
				total: 1,
				thisPage: 1,
				limit: 10,
				userData: [],
			},
		}
	},

	//部门用户数据
	userData: {
		table: [{
				title: '名称',
				key: 'nickname'
			},
			{
				title: '账号',
				key: 'account'
			},
			{
				title: '操作',
				slot: 'action',
			}
		],
		//是否显示添加用户界面
		startUserInDept: false,
		
		//添加用户界面数据操作
		addUserInDept: {
			table: [{
					title: '名称',
					key: 'nickname'
				},
				{
					title: '账号',
					key: 'account'
				},
				{
					title: '操作',
					slot: 'action',
				}
			],
			//table绑定的数据
			addUserInDeptData: {
				total: 1,
				limit: 4,
				thisPage: 1,
				userData: [],
				cacheUserData: [],
			},
		},
	}


};
root.methods = {

	//初始化部门数据
	deptInforInit: function() {
		let menuDatas = this.componentsMoudel.getData(this.$route.path);
		this.titleName = menuDatas.menuName;
		const deptMenu = this.componentsMoudel.getData('/companyManager/deptManager');
		if (deptMenu) {
			deptMenu.childMenu.forEach((item, index) => {
				if (item.menuName === '新建') {
					this.thisDeptAuthorize.add = item.hasAuth
				}
		
				if (item.menuName === '查看') {
					if (item.hasAuth) {
						this.deptGetInfo(1);
					}
					this.thisDeptAuthorize.look = item.hasAuth;
				}
				if (item.menuName === '删除') {
					this.thisDeptAuthorize.del = item.hasAuth;
				}
				if (item.menuName === '编辑') {
					this.thisDeptAuthorize.edit = item.hasAuth;
				}
				if (item.menuName === '添加成员') {
					this.thisDeptAuthorize.addUser = item.hasAuth;
				}
				if (item.menuName === '移除成员') {
					this.thisDeptAuthorize.delUser = item.hasAuth;
				}
			});
		}
		
	},

	//获取部门信息
	deptGetInfo: function(page) {
		const that = this;
		let formdata = new FormData();
		formdata.append("curPage", page);
		formdata.append("limit", this.deptDataList.limit);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').getDeptList)
			.openLoad().startPost(formdata).then((res) => {
				that.deptDataList.list = res.body.data;
				that.deptDataList.total = res.body.cum;
				that.deptDataList.thisPage = res.body.page
			});
	},

	//点击部门时加载相关数据
	operatingDept: function(data) {
		if (data === undefined) {
			this.thisEdit.deptDataOperat.deptData = {
				name: '',
				remark: ''
			};
			this.thisEdit.nameOpen = '1';
			this.thisEdit.operaType = 'add';
		} else {
			this.thisEdit.deptDataOperat.deptData = {...data};
			this.thisEdit.nameOpen = '1';
			this.thisEdit.operaType = 'edit';
			this.getDeptUserData(1);
		}
	},

	//获取部门人员数据
	getDeptUserData: function(page) {
		let formdata = new FormData();
		formdata.append("curPage", 1);
		formdata.append("limit", this.thisEdit.deptDataOperat.userList.limit);
		formdata.append("depId", this.thisEdit.deptDataOperat.deptData.id);
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').searchUserByDeptId)
			.openLoad().startPost(formdata).then((res) => {
				that.thisEdit.deptDataOperat.userList.userData = res.body.data===null?[]:res.body.data;
				that.thisEdit.deptDataOperat.userList.total = res.body.cum;
				that.thisEdit.deptDataOperat.userList.thisPage = res.body.page;
			});
	},
	
	//点击基本信息的保存按钮
	saveOperating: function(){
		if(this.thisEdit.operaType === 'add'){
			this.addDept();
		}else{
			this.updateDept();
		}
	},
	
	//修改部门信息
	updateDept: function(){
		const that = this;
		// let formdata = new FormData();
		// formdata.append("name", this.thisEdit.deptDataOperat.deptData.name);
		// formdata.append("remark", this.thisEdit.deptDataOperat.deptData.remark);
    // formdata.append("id", this.thisEdit.deptDataOperat.deptData.id);
    let formdata = {
      name: this.thisEdit.deptDataOperat.deptData.name,
      remark: this.thisEdit.deptDataOperat.deptData.remark,
      id: this.thisEdit.deptDataOperat.deptData.id
    }
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').updateDept)
			.openLoad().startPost(formdata).then((res) => {
				const deptList = [...that.deptDataList.list];
				deptList.forEach((item, index)=>{
					if(item.id === that.thisEdit.deptDataOperat.deptData.id){
						deptList[index] = {...that.thisEdit.deptDataOperat.deptData};
					}
				});
				that.deptDataList.list = deptList;
			});
	},
	
	//添加部门
	addDept: function(){
		if(this.thisEdit.deptDataOperat.deptData.name === '' || this.thisEdit.deptDataOperat.deptData.name === null ||
		this.thisEdit.deptDataOperat.deptData.name === undefined){
			this.$message({
				message:'请输入名称',
				type: 'error'
			});
			return;
		}
		const that = this;
		// const formdata = new FormData();
		// formdata.append("name", this.thisEdit.deptDataOperat.deptData.name);
    // formdata.append("remark", this.thisEdit.deptDataOperat.deptData.remark);
    let formdata = { name: this.thisEdit.deptDataOperat.deptData.name, remark: this.thisEdit.deptDataOperat.deptData.remark }
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').addDept)
			.openLoad().startPost(formdata).then((res) => {
				that.deptGetInfo(1);
				that.operatingDept();
			});
	},
	
	//删除部门
	delDept: function(deptId){
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').delDept+'/'+deptId)
			.openLoad().startPost().then((res) => {
				that.deptGetInfo(1);
				that.operatingDept();
			});
	},
	
	//部门添加人员的时用户数据查询
	selectUserByBlur: function(page){
		const that = this;
		const formdata = new FormData();
		formdata.append("account", '');
		formdata.append("curPage", page);
		formdata.append("limit", that.userData.addUserInDept.addUserInDeptData.limit);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').searchUserByName)
			.openLoad().startPost(formdata).then((res)=>{
				that.userData.startUserInDept = true;
				const userDataArray = res.body.data;
				that.userData.addUserInDept.addUserInDeptData.userData = userDataArray;
				that.userData.addUserInDept.addUserInDeptData.total = res.body.cum;
				that.userData.addUserInDept.addUserInDeptData.thisPage = res.body.page;
			})
	},
	//部门添加数据时，点击table添加时的缓存数据
	deptAddUserCache: function(item){
		if(this.userData.addUserInDept.addUserInDeptData.cacheUserData.indexOf(item) < 0){
			this.userData.addUserInDept.addUserInDeptData.cacheUserData.push(item);
		}
	},
	//部门添加数据时，点击下方tag页时删除缓存数据
	deptDelUserCache: function(item){
		const index = this.userData.addUserInDept.addUserInDeptData.cacheUserData.indexOf(item);
		this.userData.addUserInDept.addUserInDeptData.cacheUserData.splice(index, 1);
	},
	//添加用户到部门
	addUserInDeptOk: function(){
		const that = this;
		const userIds = [];
		this.userData.addUserInDept.addUserInDeptData.cacheUserData.forEach((item, index)=>{
			userIds.push(item.id);
		})
		const formdata = new FormData();
		formdata.append("depId", this.thisEdit.deptDataOperat.deptData.id);
		formdata.append("userIds", JSON.stringify(userIds));
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').addUserInDept)
			.openLoad().startPost(formdata).then((res)=>{
				that.userData.addUserInDept.addUserInDeptData.userData = [];
				that.userData.addUserInDept.addUserInDeptData.cacheUserData = [];
				that.getDeptUserData();
			})
	},
	removeUserInDept: function(item){
		const that = this;
		const formdata = new FormData();
		formdata.append("depId", this.thisEdit.deptDataOperat.deptData.id);
		formdata.append("userId", item.id);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').delUserInDept)
			.openLoad().startPost(formdata).then((res)=>{
				that.getDeptUserData();
			})
	},
	addUserInDeptCancel: function(){
		this.userData.addUserInDept.addUserInDeptData.cacheUserData = [];
	}
};
root.mounted = function() {
	this.deptInforInit();
};

FactoryComponents.initComponent(root);
